import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.6, ease: "easeOut" } }),
};

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="pt-20">
      <section className="py-24 md:py-32 bg-luxury-black">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div initial="hidden" animate="visible">
            <motion.p variants={fadeUp} custom={0} className="text-xs font-body font-medium uppercase tracking-[0.3em] text-gold mb-6">Legal</motion.p>
            <motion.h1 variants={fadeUp} custom={1} className="font-heading text-5xl sm:text-6xl font-light text-white leading-none mb-12">Privacy Policy</motion.h1>

            <motion.div variants={fadeUp} custom={2} className="space-y-10 text-white/60 font-body font-light text-sm leading-relaxed">
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Data Collection</h2>
                <p>Aristocrats JA Signature Events collects personal information solely for the purpose of providing our luxury event services. This includes names, email addresses, phone numbers, event details, and payment information submitted through our booking and contact forms.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Data Usage</h2>
                <p>Your information is used exclusively to process inquiries, manage bookings, process payments, and communicate about our services. We do not sell, trade, or otherwise transfer your personal information to third parties without your explicit consent.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Payment Security</h2>
                <p>All payment transactions are processed through Stripe, which employs enterprise-grade 256-bit SSL encryption. We do not store credit card details on our servers. Payment data is handled in full compliance with PCI DSS standards.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">AI Concierge (ARIA)</h2>
                <p>Our AI concierge ARIA processes conversation data to provide personalized assistance. Chat data is stored securely and used only to improve your experience. No sensitive personal information shared in conversations is disclosed to third parties.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Cookies</h2>
                <p>We use cookies to enhance your browsing experience. Essential cookies are required for site functionality. Analytics cookies help us understand visitor behavior. You can manage cookie preferences through our consent banner.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Drone Coverage Compliance</h2>
                <p>All drone operations comply with Jamaica Civil Aviation Authority (JCAA) regulations and applicable international aviation laws. Aerial footage is captured in compliance with local privacy and airspace regulations.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Your Rights</h2>
                <p>You have the right to access, rectify, or delete your personal data at any time. To exercise these rights or for any privacy-related inquiries, please contact us at aristocratsja@gmail.com.</p>
              </div>
              <div>
                <p className="text-white/30 text-xs">Last updated: February 2026</p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
